import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'angular-toastr/dist/angular-toastr.css';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { rootComponent } from './root.component';
import { app } from './common/app.module';
import { components } from './components/components.module';
import 'angular-auto-validate/dist/jcs-auto-validate.min';
import ngResource from 'angular-resource';
import toastr from 'angular-toastr';
import transitionLoader from 'angular-loading-bar';
import 'angular-loading-bar/build/loading-bar.min.css';
import ngCookies from 'angular-cookies';
import './common/style/_reset.scss';
import './common/style/_mixins.scss';
import './common/style/_variables.scss';
import './common/style/_common.scss';
import './common/style/_font.scss';
import Constants from './Constants';

angular
    .module('app.constant', [])
    .constant('Constants', new Constants());

export const root = angular
	.module('root', [
        uiRouter,
        ngResource,
        app,
        components,
        'jcs-autoValidate', 
        toastr,
        transitionLoader,   
        ngCookies,
        'app.constant'
    ])
    .component('root', rootComponent)
    .config((cfpLoadingBarProvider, $urlRouterProvider, $httpProvider, $provide) => {
        'ngInject';

        cfpLoadingBarProvider.includeSpinner = false;
        $urlRouterProvider.otherwise('/');
        //$urlRouterProvider.otherwise(() => ({ state: 'app.dashboard.HomeBanner'})
        $provide.factory('myHttpInterceptor', function ($q, $injector) {

            return {
				 // optional method
				'request': function(config) {
				  // do something on success
					const AuthService = $injector.get('AuthService');
					config.headers.Authorization = AuthService.getAuthorizationHeader();
				  	return config;
				},

				// optional method
                'requestError': function(rejection) {
                    // do something on error
                    
                    return $q.reject(rejection);
                    },
                'response': function (response) {
                    // do something on success
                    return response || $q.when(response);
                },
                'responseError': function (rejection) {
                    // do something on error
                    if ((rejection.config.url.indexOf('https://graph.facebook.com/') === -1 && rejection.status === 404) || rejection.status === 401) {
                        const AuthService = $injector.get('AuthService');
                        AuthService.expireSession();
                    }
                    return $q.reject(rejection);
                }
            };
        });
        $httpProvider.interceptors.push('myHttpInterceptor');
    })
    // cloud ip
    .constant('API_ENDPOINT', 'https://cms.gettherescny.org/api/')

    // local ip
    // .constant('API_ENDPOINT', 'http://191.168.0.128:1340/')
    .name;



// WEBPACK FOOTER //
// ./src/app/root.module.js